<template>
  <div class="main">
    <report-top><template slot="search">
        <ly-search v-model="searchItem.keyword" @search="search"></ly-search> </template></report-top>
    <selectTool ref="selectTool"><template slot="btn"><Button @click="getSearchItem" type="error"
          class="chaxun">查询</Button><Button @click="openAdd" type="primary" class="chaxun">新增</Button></template>
    </selectTool>

    <Table border :columns="columns" :data="tableData" :height="utils.setTableHeight(200)">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="openReset(row)">重置密码</Button>
        <Button size="small" @click="opemUpdate(row)">编辑</Button>
        <Button size="small" @click="del(row)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page :current="1" :total="total" :page-size="searchItem.pageSize" :page-size-opts="[10, 50, 100]" show-total
          show-elevator show-sizer @on-change="changePage" @on-page-size-change="pageSizeChange"></Page>
      </div>
    </div>
    <form-model :title="isAdd ? '新增数据' : '编辑数据'" width="700" ref="formModel">
      <Select slot="roleList" v-model="item.roleIdList" multiple>
        <Option v-for="x in roleList" :value="x.id" :key="x.id">{{
          x.name
        }}</Option>
      </Select>
      <alot-item slot="groupIdList" v-model="groupList" @on-click="openGroupForm = true" keyw="name"></alot-item>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Drawer class="my-drawer" v-model="openGroupForm">
      <group-tree :noAutoLoad="true" :sousuo="true" @group="reGroup"></group-tree>
    </Drawer>
    <Modal v-model="openResetForm" :title="resetTitle" :z-index="30" footer-hide width="400">
      <Form ref="resetPW" :model="resetPw" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
          <FormItem label="密码" prop="resetPassword">
            <Input v-model="resetPw.resetPassword" maxlength="20" show-word-limit placeholder="请输入" />
          </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="12">
          <div class="btn-wrap">
            <Button :disabled="resetPw.resetPassword.length < 6" type="primary"
              @click="resetPasswordFun('resetPW')">提交</Button>
          </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
var roleList = [];
export default {
  data() {
    return {
      openGroupForm: false,
      isAdd: false,
      modalTitle: "",
      columns: [
        {
          type: "index",
          align: "center",
          width: 70,
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        account: "",
        enabled: true,
        password: "",
        name: "",
        pid: "0",
        groupId: "",
        groupName: "",
        roleIdList: [],
        groupIdList: [],
        labelList: [],
        remark: "",
        //avatar: '',
      },
      groupList: [],

      ruleValidate: {
        account: { required: true, message: "必填字段" },
        password: { required: true, message: "必填字段" },
        roleIdList: { required: true, message: "必填字段" },
        groupName: { required: true, message: "必填字段" },
      },
      forms: [
        {
          title: "账号",
          key: "account",
          type: "Input",
          required: true,
        },
        {
          title: "密码",
          key: "password",
          type: "Input",
          noTable: true,
          required: true,
        },
        {
          title: "备注名",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "联系电话",
          key: "tel",
          type: "Input",
          required: true,
        },
        {
          title: "所属部门",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
        },
        {
          title: "所属角色",
          key: "roleIdList",
          key2: 'roleNames',
          multiple: true,
          type: "Select",
          selectType: "obj",
          selectItems: roleList,
        },
        {
          title: "详细备注",
          key: "remark",
          type: "Input",
        },
        {
          title: "其他部门",
          key: "groupIdList",
          key2: "groupNames",
          slotForm: "groupIdList",
          span: 24,
        },
      ],
      openPlatform: false,
      resetPw: { resetId: "", resetPassword: "" },
      resetTitle: "",
      openResetForm: false,
      openGroup: false,
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "2,0",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.bm + "/user/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].roleNames = data[i].roleNameList.join("/");
          data[i].groupNames = data[i].groupNameList.join("/");
        }
        this.tableData = data;
        console.log('zhanghao', data);
      });
    },
    exportAll() {
      var params = [
        {
          name: "keyword",
          value: this.searchItem.keyword,
        },
        {
          name: "groupIdList",
          value: this.searchItem.groupIdList,
        },
      ];
      this.utils.exportData(axios.dm + "/person/export", params);
    },
    addUpdate(name) {
      var t = this.groupList;
      var arr = [];
      for (let i = 0; i < t.length; i++) {
        arr.push(t[i].id);
      }
      this.item.groupIdList = arr;
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }

      //this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.bm + "/user/add",
          data: this.item,
        }).then((res) => {
          console.log(res);
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        axios({
          method: "post",
          url: axios.bm + "/user/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.bm + "/user/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = row;
      this.item.password = "******";
      this.getGroup(row.groupIds, row.groupNameList);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    openReset(row) {
      this.openResetForm = true;
      this.resetPw.resetId = row.id;
      this.resetTitle = "重置" + row.account + "密码";
    },
    resetPasswordFun() {
      axios({
        method: "post",
        url: axios.bm + "/user/resetPassword",
        data: {
          id: this.resetPw.resetId,
          password: this.resetPw.resetPassword,
        },
      }).then((res) => {
        console.log(res);

        if (res) {
          this.openResetForm = false;
          this.getList();
        }
      });
    },
    search() {
      this.getList();
    },
    getRoleList() {
      roleList.length = 0;
      axios({
        method: "post",
        url: axios.bm + "/role/list",
        data: {},
      }).then((res) => {
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          roleList.push(data[i]);
        }
        //roleList = data.filter((item) => !item.keep);
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    //点击用户组将数据传递给表单
    reGroup(v) {
      var obj = { id: v.id, name: v.name };
      //判断数组是否包含obj对象
      var result = this.groupList.some((item) => {
        if (item.id == obj.id) {
          return true;
        }
      });
      if (result) {
        this.$Message.error("（" + obj.name + "）已存在");
      } else {
        this.groupList.push(obj);
      }
      console.log(this.groupList);
    },
    getGroup(groupIds, groupNameList) {
      var arr = [];
      for (let i = 0; i < groupIds.length; i++) {
        var obj = {
          id: groupIds[i],
          name: groupNameList[i],
        };
        arr.push(obj);
      }
      this.groupList = arr;
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);

    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
    this.getRoleList();
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/information/user.vue